import {
  Div, FormItem, FormLayout, Group, Panel, PanelHeader, PanelHeaderBack, Title
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo } from 'react';
import { AppPanels, AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';
import { $currentNominationLabel, $currentNomitionPretendents } from 'src/entity/Pretendents';
import { Cover } from 'src/shared/ui/cover';
import { SecondStageVoitingCard } from './SecondStageVoitingCard/SecondStageVoitingCard';
import styles from './styles.module.scss';

interface ISecondStageVoitingPanel {
  id: AppPanelsT;
}

export const SecondStageVoitingPanel = memo(
  ({ id }: ISecondStageVoitingPanel) => {
    const [
      currentNomitionPretendents,
      currentNominationLabel,
      onSetActivePanel
    ] = useUnit([
      $currentNomitionPretendents,
      $currentNominationLabel,
      setActivePanel
    ]);

    if (!currentNomitionPretendents) return null;

    const nominees = currentNomitionPretendents.map(({ nomineeId, nomineeLabel, image }) => (
      <SecondStageVoitingCard
        key={nomineeId}
        nomineeId={nomineeId}
        nomineeLabel={nomineeLabel}
        image={image}
        nomineeGroupName={currentNominationLabel}
      />
    ));

    const onBackClickHandler = () => {
      onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS);
    };

    return (
      <Panel id={id}>
        <PanelHeader
          visor={false}
          separator={false}
          transparent
          style={{ width: '0px' }}
          before={(
            <PanelHeaderBack
              onClick={onBackClickHandler}
            />
          )}
        />
        <Group className={styles.group}>
          <Div className={styles.poll__form}>
            <FormLayout className={styles.form}>
              <Div>
                <FormItem className={styles.voiting_container}>
                  <Title className={styles.title} weight='3' level='2'>
                    {currentNominationLabel}
                  </Title>
                  {nominees}
                </FormItem>

              </Div>
            </FormLayout>
          </Div>
        </Group>
        <Cover />
      </Panel>
    );
  }
);
